module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    staticClass: "editDialogsRow",
    attrs: {
      "width": "350px",
      "persistent": ""
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n    Add Location\n    "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    staticClass: "primary--text text--lighten-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-xs-center justify-center"
  }, [_c('h2', [_vm._v("Edit " + _vm._s(_vm.trial.trialName) + " Locations")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.editedLocations), function(item) {
    return _c('v-flex', {
      key: item.objectName,
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h3', [_vm._v("Current Locations:")]), _vm._v(" "), _vm._l((_vm.locationsGetter), function(item) {
    return _c('div', {
      key: item.locationID
    }, [_vm._v("\n              " + _vm._s(item.locationName) + "\n            ")])
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "trial.trialLocations",
      "label": "Add Trial Locations",
      "items": _vm.locations,
      "item-value": "locationId",
      "item-text": "locationName",
      "id": "trial.trialLocations",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your locations",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.editedLocations),
      callback: function($$v) {
        _vm.editedLocations = $$v
      },
      expression: "editedLocations"
    }
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "grey white--text",
    attrs: {
      "depressed": "",
      "to": "/location/new"
    }
  }, [_vm._v("Create New Location")])], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "grey lighten-1 white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary ",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.onSaveChanges
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64e4417d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Edit/EditTrialLocationsDialog.vue
// module id = 691
// module chunks = 1